import Vue from 'vue';
import VueRouter from 'vue-router';

import Menu from '../views/Menu.vue';

import NumberDictionary from '../views/admin/NumberDictionary.vue';
import DictionaryContent from '../views/admin/DictionaryContent.vue';
import AccountInfo from '../views/admin/AccountInfo.vue';
import SendRecord from '../views/admin/SendRecord.vue';
import SceneSms from '../views/admin/SceneSms.vue';
import LoginAuto from '../views/admin/LoginAuto.vue';
import Login from '../views/Login.vue';
import ReportingManagement from '../views/admin/ReportingManagement.vue';
import TemplateManagement from '../views/admin/TemplateManagement.vue';

import MobileRecord from '../views/mobile/MobileRecord.vue';
import MobileDownload from '../views/mobile/MobileDownload.vue';
import MobileSend from '../views/mobile/MobileSend.vue';
import MobileFilter from '../views/mobile/MobileFilter.vue';

import { sessionData } from "../storage/storage";

Vue.use(VueRouter)
const routes = [
  { path: '/', redirect: '/Login' },
  { path: '/Menu', component: LoginAuto },
  { path: '/Login', component: Login },
  { path: '/Menu', 
    component: Menu,
    children: [
      { 
        path: '/', 
        redirect: 'Login', 
      },
      { 
        path: '/LoginAuto', 
        component: LoginAuto, 
        meta: {
          requireAuth: false,  
        }  
      },
      { 
        path: '/NumberDictionary', 
        component: NumberDictionary, 
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/DictionaryContent', 
        component: DictionaryContent, 
        meta: {
          requireAuth: true,  
        }  
      },
      {
        path: '/AccountInfo', 
        component: AccountInfo, 
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/SendRecord', 
        component: SendRecord, 
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/SceneSms', 
        component: SceneSms, 
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/ReportingManagement', 
        component: ReportingManagement, 
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/TemplateManagement', 
        component: TemplateManagement, 
        meta: {
          requireAuth: true,  
        }  
      },
    ]
  },
  { 
    path: '/MobileRecord', 
    component: MobileRecord, 
    meta: {
      requireAuth: true,  
    }  
  },
  { 
    path: '/MobileDownload', 
    component: MobileDownload, 
    meta: {
      requireAuth: true,  
    }  
  },
  { 
    path: '/MobileSend', 
    component: MobileSend, 
    meta: {
      requireAuth: true,  
    }  
  },
  { 
    path: '/MobileFilter', 
    component: MobileFilter, 
    meta: {
      requireAuth: true,  
    }  
  },
]
const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (sessionData('get','token')) {
      next();
    } else {
      next('/Login')
    }
  }else {
    next();
  }
});
export default router;
